// eslint-disable-next-line import/no-unresolved
import { Securities } from '@creditsights/cs-web';
import { DataLoadError, Loader } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { useQueryClient } from 'react-query';
import { useOutletContext, useParams } from 'react-router-dom';
import useFetchCompanyDeals from '../../../hooks/deals/useFetchCompanyDeals';
import { CompanyOutletContext } from '../Company';
import { useDocumentTitle } from '../../../hooks/common';
import styles from './CompanyDealsTab.module.scss';

const cx = classNames.bind(styles);

const DEAL_TYPE_ROUTES: Record<string, string> = {
  loans: 'loan',
  bonds: 'bond',
};

const CompanyDealsTab = (): React.ReactElement => {
  const client = useQueryClient();
  const { issuerId, dealType = 'bonds' } = useParams();
  const { company } = useOutletContext<CompanyOutletContext>();
  const { isError, refetch, isLoading } = useFetchCompanyDeals(issuerId!, { take: 1, enabled: company?.canAccess });

  useDocumentTitle(`${company.displayName}: Deals Pipeline`);

  const renderContent = () => {
    if (isLoading) {
      return <Loader position="center" />;
    }

    if (isError) {
      return <DataLoadError onRetryClick={refetch} />;
    }

    return <Securities client={client} type={DEAL_TYPE_ROUTES[dealType]} companyId={issuerId} />;
  };

  return (
    <section className={cx('body')}>
      <header className={cx('header')}>{renderContent()}</header>
    </section>
  );
};

export default CompanyDealsTab;
